import { Component, ElementRef, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TagComponent, TagStatusType } from '@shared/components/tag/tag.component';
import { TranslateModule } from '@ngx-translate/core';
import { getDarkBrandLogo } from '@shared/helpers/getBrandLogo';

@Component({
  selector: 'order-collapse',
  imports: [CommonModule, RouterModule, TagComponent, TranslateModule],
  templateUrl: './order-collapse.component.html',
  styleUrls: ['./order-collapse.component.scss'],
})
export class OrderCollapseComponent {
  @Input() order?: any;

  @Input() type?: 'order' | 'invoice' | 'ticket';
  @Input() number?: string;
  @Input() date?: string;
  @Input() status?: string | null;
  @Input() totalPrice?: number;

  isActive = false;

  private hostElement = inject(ElementRef);

  get hostClasses(): string[] {
    const classList = Array.from((this.hostElement.nativeElement as HTMLElement).classList);

    return classList;
  }

  toggleAccordion() {
    this.isActive = !this.isActive;

    return;
  }

  getBrandLogo(brandName: string): string {
    return getDarkBrandLogo(brandName);
  }

  getTagType(): TagStatusType {
    if (this.status === 'APP') return 'success';
    if (this.status === 'PEN') return 'warning-dark';
    if (this.status === 'REJ') return 'danger';
    if (this.status === 'PAC') return 'neutral';
    if (this.status === 'CAN') return 'neutral';
    return 'neutral';
  }

  getStatus(): string {
    if (this.status === 'APP') return 'order.status.approved';
    if (this.status === 'PEN') return 'order.status.pending';
    if (this.status === 'REJ') return 'order.status.rejected';
    if (this.status === 'PAC') return 'order.status.partially_approved';
    if (this.status === 'CAN') return 'order.status.canceled';
    return 'order.status.pending';
  }

  handleDownloadInvoice() {
    // eslint-disable-next-line no-console
    console.log('Download invoice');
  }
}
